// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__N_4H2","description":"PatientConsentPreview_description__1qV6k"};